import { useEffect, useMemo, useState } from 'react';
import ContactUsMinus from 'components/Icons/ContactUsMinus';
import ContactUsPlus from 'components/Icons/ContactUsPlus';
import Link from 'next/link';

const FAQ = ({ faq }: { faq: any }) => {

    // Shipping for per region
    const [faqs, setFaqs] = useState<any>([]);

    useEffect(() => {
        const parseFAQs = () => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(faq.htmlContent, 'text/html');

            const faqElements = Array.from(doc.querySelectorAll('.wp-block-columns'));
            const faqs = faqElements.slice(0, 5).map(faq => {
                const questionElement = faq.querySelector('#accordion_title p') || faq.querySelector('p');
                const answerElement = faq.querySelector('.wp-block-column:nth-child(2)');

                if (questionElement && answerElement) {
                    // Remove the mx-auto class from the answer's HTML
                    const cleanedAnswerHTML = answerElement.innerHTML.replace(/mx-auto/g, '').trim();
                    return {
                        question: questionElement.innerHTML.trim(),
                        answer: cleanedAnswerHTML,
                        isOpen: false
                    };
                }
                return null;
            }).filter(faq => faq !== null);

            return faqs;
        };
        if(faq) {
            const fetchedFAQs = parseFAQs();
            setFaqs(fetchedFAQs);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const toggleFAQ = (index: number) => {
        setFaqs((prevFaqs: any) =>
            prevFaqs.map((faq: any, i: any) =>
                i === index ? { ...faq, isOpen: !faq.isOpen } : faq
            )
        );
    };

    return (
        <div className="mt-8 md:mt-[60px]">
            <h2 className="text-2xl text-center text-[#2A2A2A]">FAQ</h2>
            <div className="space-y-4 mt-[20px]">
                {faqs.map((faq: any, index: any) => (
                    <div
                        key={index}
                        className="rounded-[12px] px-[24px] py-[30px]"
                        style={{ border: '1px solid var(--Grey---04, #CACACA)' }}
                    >
                        <div className="flex w-full cursor-pointer" onClick={() => toggleFAQ(index)}>
                            <div className="flex-1">
                                <p className="text-base">{faq.question}</p>
                            </div>
                            <div className="flex items-center">
                                {faq.isOpen ? <ContactUsMinus /> : <ContactUsPlus />}
                            </div>
                        </div>
                        <div>
                            {faq.isOpen && <p className="text-base mt-[40px] text-[#616161]" dangerouslySetInnerHTML={{
                                __html: faq.answer
                            }}></p>}
                        </div>
                    </div>
                ))}
            </div>
            <div className="mt-4 text-center">
                <Link href="/about-us/faq" className="text-[#00AEC7]">View all FAQ</Link>
            </div>
        </div>
    );
};

export default FAQ;
